import { useRef } from 'react'
import { toast } from 'react-toastify';
import { useFormContext, useWatch } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import { uploadIcon, helperDoc } from '../../assets/icons';
import { useDispatch, useSelector } from 'react-redux';
import { setcsvName } from "redux/counterSlice";
import * as myconst from "../../constants/index"

const StepThree = ({ handlePrev }: any) => {
    const fileInputRef: any = useRef(null);
    const dispatch = useDispatch();
    const csvName = useSelector((state: any) => state.counter.csvName);
    const { formState: { errors }, setValue, } = useFormContext();
    // const fileTypes = ["text/csv", "text/xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"]

    const handleButtonClick = () => {
        // Trigger the file input when the button is clicked
        fileInputRef.current.click();
    };

    const handleFileChange = async (event: any) => {
        const file = event.target.files[0];
        const size = Math.round(event?.target?.files[0]?.size / 1048576);
        const fileType = file?.name?.split('.').pop();
        if (file) {
            if (size < 10) {
                if (fileType === 'xlsx' || fileType === 'csv') {
                    // if (fileTypes.includes(file.type)) {
                    const base64Code: any = await myconst.fileToBase64(file)
                    const correctBase64 = await myconst.manipulateBase64Data(base64Code)
                    dispatch(setcsvName(file?.name));
                    setValue("csv_master_data", correctBase64);
                    toast.success("Document uploaded successfully", {
                        style: {
                            backgroundColor: '#F1F1F1', // Grey background
                        }
                    })
                } else {
                    fileInputRef.current.value = null;
                    // dispatch(setcsvName(''));
                    toast.error("File is not supported", {
                        style: {
                            backgroundColor: '#F1F1F1', // Grey background
                        }
                    })
                }
            } else {
                fileInputRef.current.value = null;
                // dispatch(setcsvName(''));
                toast.error("File size should not be more than 10 MB", {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
            }
        }
    }

    return (
        <div className='stepper-main'>
            <div className='stepper-form'>
                <div className='upload-file-step'>
                    <small>Refer to this sample file before proceeding with any process: <b style={{ cursor: "pointer" }} onClick={() => myconst.downloadBase64File()}>Sample_Schema_Mapping.xlsx</b></small>
                    <div className='home-search' onClick={handleButtonClick}>
                        <InputText style={{ cursor: "auto" }} value={csvName.length >= 42 ?`${csvName.slice(0,42)}...` : csvName} className='radius-input input-box' placeholder='Upload Document' readOnly title={csvName} />
                        <input id='uploadDoc' ref={fileInputRef} type="file" placeholder='Upload document' onChange={handleFileChange} className="d-none" accept='.csv, .xlsx' name="fileUpload" />
                        <i className='last-icon'><img src={uploadIcon} alt='upload-icon' /></i>
                    </div>
                    <p className='helper-text'><i><img src={helperDoc} alt='qmate-icon' /></i><b>File formats:</b> .xlsx, .csv file with a maximum file size limit of <b>10 MB.</b></p>
                </div>
            </div>
            <div className='stepper-footer'>
                <div className='stepper-wrapper stepper-wrapper-ft'>
                    <div className='stepper-footer-inner'>
                        <div className='stepper-footer-left'></div>
                        <div className='stepper-footer-right'>
                            <button type="button" className="grey-outline-btn mr-4" onClick={() => handlePrev()}>Previous</button>
                            <button type="submit" className="outline-active-btn">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default StepThree;